(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.CsvIconSvg = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CsvIcon = function CsvIcon() {
    return _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "49",
        viewBox: "0 0 41 49"
      },
      _react2.default.createElement(
        "g",
        { fill: "none", fillRule: "evenodd" },
        _react2.default.createElement("rect", { width: "38", height: "46", x: "3", fill: "#757D99", rx: "1" }),
        _react2.default.createElement("rect", { width: "38", height: "46", y: "3", fill: "#DFE1E7", rx: "1" }),
        _react2.default.createElement("rect", {
          width: "16.418",
          height: "1.59",
          x: "5.63",
          y: "29.667",
          fill: "#47506B",
          rx: ".795"
        }),
        _react2.default.createElement("rect", {
          width: "10.418",
          height: "1.59",
          x: "5.63",
          y: "34.8",
          fill: "#47506B",
          rx: ".795"
        }),
        _react2.default.createElement("rect", {
          width: "22.418",
          height: "1.59",
          x: "5.63",
          y: "39.933",
          fill: "#47506B",
          rx: ".795"
        }),
        _react2.default.createElement(
          "text",
          {
            fill: "#2D344B",
            fontFamily: "ProximaNova-Regular, Proxima Nova",
            fontSize: "16"
          },
          _react2.default.createElement(
            "tspan",
            { x: "7", y: "19" },
            "csv"
          )
        )
      )
    );
  };

  exports.default = CsvIcon;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/icons/CsvIcon.svg.js
// module id = 2037
// module chunks = 1